import React from 'react';
import { AlertTriangle } from 'lucide-react';

/** Bandeau compact à placer à droite du titre (sections CRM) quand l'email Vinted n'est pas synchronisé. */
export const CrmEmailSyncBanner: React.FC<{ className?: string }> = ({ className = '' }) => (
  <div
    className={`flex items-start gap-2 rounded-xl border border-orange-200 bg-orange-50/95 px-3 py-2.5 max-w-xl ${className}`}
  >
    <AlertTriangle size={16} className="text-orange-500 flex-shrink-0 mt-0.5" />
    <p className="text-xs sm:text-sm text-orange-900 leading-snug">
      <span className="font-semibold">Aucune adresse Gmail Vinted reliée.</span>{' '}
      L’adresse liée à votre compte d’inscription n’est pas encore connectée à notre site. Suivez les étapes dans{' '}
      <strong className="text-orange-950">Configuration</strong> pour activer la synchronisation.
    </p>
  </div>
);
